<template>
  <v-container>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-thead"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-layout
      v-if="!$apollo.loading && rankingResult"
      wrap
      class="trader-result"
    >
      <v-flex
        v-if="allowAdvancedView"
        md4
        xs12
      > 
        <span>{{ $t('rankings.totalEarned') }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t('rankings.totalEarnedTooltip') }}</span>
        </v-tooltip>   
        <p>
          {{ rankingResult.base_currency | renderSymbol }} 
          {{ rankingResult.total_earned | formatMoney }}
        </p>
      </v-flex>
      
      <v-flex
        :class="allowAdvancedView ? 'md4' : 'md3'"
        xs12
      > 
        <span>{{ $t('rankings.selfEarned') }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t('rankings.selfEarnedTooltip') }}</span>
        </v-tooltip>  
      
        <p>
          {{ rankingResult.base_currency | renderSymbol }} 
          {{ rankingResult.self_earned | formatMoney }}
        </p>
      </v-flex>
      <v-flex
        v-if="allowAdvancedView"
        md4
        xs12
      > 
        <span>{{ $t('rankings.invEarned') }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t('rankings.invEarnedTooltip') }}</span>
        </v-tooltip>   
        <p>
          {{ rankingResult.base_currency | renderSymbol }} 
          {{ rankingResult.investors_earned | formatMoney }}
        </p>
      </v-flex>
      <v-flex
        :class="allowAdvancedView ? 'md4' : 'md3'"
        xs12
      > 
        <span>{{ $t('rankings.upnl') }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t('rankings.upnlTooltip') }}</span>
        </v-tooltip>   
      
        <p :class="colorPnL(rankingResult.self_upnl)">
          {{ rankingResult.self_upnl }}%
        </p>
      </v-flex>
      <v-flex
        :class="allowAdvancedView ? 'md4' : 'md3'"
        xs12
      > 
        <span>{{ $t('rankings.maxDrawdown') }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ $t('rankings.maxDrawdownTooltip') }} {{ rankingResult.max_drawdown_since | moment('L') }}</span>
        </v-tooltip>   
      
        <p class="text-neutral">
          {{ rankingResult.max_drawdown }}%
        </p>
      </v-flex>
      <v-flex
        :class="allowAdvancedView ? 'md4' : 'md3'"
        xs12
      > 
        <span>{{ $t('rankings.drawdownExceeded') }}</span>  
        <p class="text-neutral">
          {{ rankingResult.drawdown_exceeded ? $t('aff.Yes') : $t('aff.No') }}
        </p>
      </v-flex>
    </v-layout>
  </v-container>  
</template>

<script>
const RANKING_RESULT_QUERY = require('@/graphql/queries/RankingResult.gql');
import { mapGetters } from "vuex";

export default {
  name: 'TraderResult',
  props: {
    projectId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      loading: false
    }
  },
   computed: {
    ...mapGetters("user", ["getUser"]),
    allowAdvancedView() {
      return this.getUser && (this.getUser.pack == 'Premium' || this.getUser.pack == 'VIP')
    }
  },
  apollo: {
    rankingResult: {
      query: RANKING_RESULT_QUERY,
      variables() {
        return {
          project_id: this.projectId
        }
      },
      fetchPolicy: 'network-only',
      pollInterval: 60*1000,
    }
  },
  beforeDestroy() {
    this.$apollo.queries.rankingResult.stopPolling()
  },
};
</script>

<style lang="scss">
 .trader-result {
  padding: 10px;
  span {
    font-size: 11px;
    font-weight: 600;
    color: #7f97ab;
    text-transform: uppercase;
  }
  p {
    font-weight: 700;
    font-size: 16px;
  }
  .v-icon {
    margin-left:4px;
    font-size: 16px;
  }
 }
</style>
